/** @format */

import { createContext, use, useContext, useEffect, useState } from "react";
import { LANGUAGES } from "../constants";
import ES from "../locales/es/translation.json";
import EN from "../locales/en/translation.json";
import DE from "../locales/de/translation.json";
import FIL from "../locales/fil/translation.json";
import PT from "../locales/pt/translation.json";
import FR from "../locales/fr/translation.json";
import ZH_CN from "../locales/zh-CN/translation.json";
import JA from "../locales/ja/translation.json";
const LanguageContext = createContext();

export function LanguagueProvider({ children }) {
  const [language, setLanguage] = useState(LANGUAGES.Español);

  useEffect(() => {
    const langLS = localStorage.getItem("lng");
    if (langLS) {
      setLanguage(langLS);
    } else {
      localStorage.setItem("lng", LANGUAGES.Español);
    }
  }, []);

  const translations = {
    [LANGUAGES.Español]: ES,
    [LANGUAGES.English]: EN,
    [LANGUAGES.Deutsch]: DE,
    [LANGUAGES.Filipino]: FIL,
    [LANGUAGES.Português]: PT,
    [LANGUAGES.Français]: FR,
    [LANGUAGES["简体中文"]]: ZH_CN,
    [LANGUAGES["日本語"]]: JA,
  };

  const t = (page, section, element) => {
    const translation = translations[language];
    return translation?.[page]?.[section]?.[element] ?? "Cant find translation";
  };

  const updateLanguage = (language) => {
    setLanguage(language);
    localStorage.setItem("lng", language)
  };
  return <LanguageContext.Provider value={{ t, language, updateLanguage }}>{children}</LanguageContext.Provider>;
}

export const useLanguageContext = () => useContext(LanguageContext);
